import { QRCodeSVG } from 'qrcode.react';
import React, { useMemo } from 'react';

import { KioskType } from '../../../@types';
import { useKioskManager } from '../../../hooks/useKioskManager';

type QRCodeProps = {
  url: string;
};

const QRCode: React.FC<QRCodeProps> = ({ url }) => {
  const { kiosk, kioskMode } = useKioskManager();

  const qrCodeSize = useMemo(
    () =>
      kiosk && kioskMode && kiosk.model === KioskType.BA_TABLET ? 366 : 169,
    [kiosk, kioskMode],
  );

  return (
    <div>
      <QRCodeSVG value={url} size={qrCodeSize} />
    </div>
  );
};

export default QRCode;
